module.exports = __webpack_public_path__ + "img/compact.6f8637f9.png";